
import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const GamblingSafetyTopBarWrapper = withConfig(theme => styled('div', { label: 'GamblingSafetyTopBarWrapper' })`
    align-items: center;
    background-color: ${theme.star.gamblingSafetyTopBar.bgColor};
    display: flex;
    gap: 32px;
    height: 40px;
    justify-content: center;
`);

export const GamblingSafetyLink = withConfig(theme => styled('a', { label: 'GamblingSafetyLink' })`
    align-items: center;
    color: ${theme.star.gamblingSafetyTopBar.txtColor};
    display: flex;
    position: relative;
    &::after {
        background: ${theme.star.gamblingSafetyTopBar.bgColorSecondary};
        content: '';
        height: 12px;
        inset: 0 auto 0 100%;
        margin: auto 0 auto 16px;
        position: absolute;
        width: 1px;
    }
    &:last-of-type {
        &::after {
            content: none;
        }
    }
`);
